import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const PrivateRoute = ({ element: Component }) => {
  const accessToken = Cookies.get(process.env.REACT_APP_ACCESS_TOKEN_COOKIE);
  const isAuthenticated = !!accessToken;
  return isAuthenticated ? Component : <Navigate to="/" />;
};

export default PrivateRoute;